export default __webpack_public_path__ + "static/montserrat-v15-latin-800italic-fe82abb0bcede51bf724254878e0c374.woff";